import React from 'react';

import ReadOnlyInput from '@features/supplier-onboarding/components/ReadOnlyInput';
import RejectField from '@features/supplier-onboarding/components/RejectField';

import { useSupplierInfo } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { supplierWorkflowSteps } from '@/constants/constant';

const FactoryBasicInfo = ({ setActiveStep }) => {
	const supplierInfo = useSupplierInfo();
	const stepName = 'FACTORY_BASIC_INFORMATION';

	const renderOfficeOrFactoryLocation = (fieldName) => {
		return (
			<div className="location-row row m-0">
				<div className="col-md-6 pr-0">
					<ReadOnlyInput
						label="Location"
						name="officeCountry"
						value={supplierInfo?.[fieldName]?.countryResponse?.name}
						hideIcon={true}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-6 pl-0">
					<ReadOnlyInput
						label="."
						name="officeCity"
						className="invisible"
						value={supplierInfo?.[fieldName]?.city}
						hideIcon={true}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						name="officeAddress"
						value={supplierInfo?.[fieldName]?.address}
						hideIcon={true}
						stepName={stepName}
					/>
				</div>
				<RejectField stepName={stepName} name={fieldName} />
			</div>
		);
	};

	return (
		<div className="information-form">
			<h3 className="title weight-700 gray_dark_01">Factory Basic Information</h3>
			<div className="row">
				<div className="col-md-12">
					<ReadOnlyInput
						label="Factory Name"
						name="name"
						value={supplierInfo?.name}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Group Name"
						name="groupName"
						value={supplierInfo?.groupName}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Establishment Year"
						name="establishmentYear"
						value={supplierInfo?.establishmentYear}
						stepName={stepName}
					/>
				</div>
				{renderOfficeOrFactoryLocation('officeLocation')}
				<div className="col-md-12">
					<div className="custom-chekbox ">
						<div className="form-group">
							<input
								type="checkbox"
								id="person2"
								name="Company"
								disabled
								checked={!!supplierInfo?.hasSameOfficeAndFactoryLocation}
								onChange={() => false}
							/>
							<label className="regular-14" htmlFor="person2">
								<span>The office location is the same as the factory location.</span>
							</label>
						</div>
					</div>
				</div>
				{!supplierInfo?.hasSameOfficeAndFactoryLocation &&
					renderOfficeOrFactoryLocation('factoryLocation')}
				<div className="col-md-12">
					<div className="submit-button">
						<button
							className="button size32 w-100"
							onClick={() => setActiveStep(supplierWorkflowSteps.PRODUCT_INFORMATION)}
						>
							Next
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FactoryBasicInfo;
